import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectIsQbrDocumentFinalized = createSelector(
  [selectQbrState],
  ({ isFinalized }) => isFinalized
)
